import React from 'react'
import Script from 'next/script'

type InitScriptsProps = {
    scripts: string[]
}

export const InitScripts = ({
    scripts = []
}: InitScriptsProps): JSX.Element => {
    return (
        <>
            {scripts.map((script: string, idx: number) => (
                <Script
                    key={idx}
                    id={`tag-manager-script-${idx}`}
                    dangerouslySetInnerHTML={{ __html: script }}
                />
            ))}
        </>
    )
}
